import React from 'react';
import { TravelAssistantLauncher } from './assistant/TravelAssistant';

// Global entry point: the floating voice button opens the unified ChatGPT travel assistant
const GlobalVoiceAssistant = () => <TravelAssistantLauncher />;

export default GlobalVoiceAssistant;
